export default "/images/vendor/flag-icon-css/flags/1x1/mg.svg?41929500e241af7a7838aba32baa39c0";